import {combineReducers} from 'redux';
import {userFeedbackReducer} from './userFeedbackView';
import {profileReducer} from './profile/reducer';
import {uiCalendarReducer} from './calendar/reducer';
import {uiMeetingsReducer} from './meetings/reducer';
import {workingHoursReducer} from './workingHours';
import {workspaceReservationReducer} from './workspaceReservation';
import {usabilityReducer} from './usability/reducer';

export const uiReducer = combineReducers({
  calendar: uiCalendarReducer,
  profile: profileReducer,
  userFeedback: userFeedbackReducer,
  meetings: uiMeetingsReducer,
  workingHours: workingHoursReducer,
  workspaceReservation: workspaceReservationReducer,
  usability: usabilityReducer,
});
